module.exports = __webpack_public_path__ + "static/media/main_logo.ac98148c.png";